/* eslint-disable no-plusplus */
/* eslint-disable no-continue */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { reactive } from 'vue';
import PcheckerService from '@/services/api/pchecker-service';
import { State } from '@/models/ProxyChecker';
import { ResponseData } from '@/models/FreeProxies';

export const state: State = reactive({
  input: '',
  proxies: [],
  Data: new FormData(),
  response: '',
  total_proxies: 0,
  working_proxies: 0,
  dead_proxies: 0,
  working_proxies_array: [],
  working_proxies_list: '',
  loading: false,
  isShow: false,
  showChecker: true,
  showOutput: false,
  error: false,
  lines: [],
  flag: '',
});

const IP: string[] = [];

/* export const _ = () => {
  console.log(state.input.replace(/ /g, '').split('\n'));
  const input: any = state.input.replace(/ /g, '').split('\n');

  function ValidateIPaddress() {
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\
      .(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\
      .(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\
      .(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      .test(
        state.input
      )
    ) {
      console.log('valid ip');
    } else {
      console.log('You have entered an invalid IP address!');
    }
  }
  ValidateIPaddress();
  // const input = state.input.split(' ');
  // console.log(input);
}; */

const loadIPinput = () => {
  const data: string = state.input;
  const lines: string[] = data.replace(/ /g, '').split('\n');
  // state.lines = lines;

  // console.log('lines', lines);

  for (let i = 0; i < lines.length; i++) {
    const pr = lines[i];
    // console.log(pr, 'pr');

    const line: string[] = pr.split(':');

    // console.log('line', line);

    if (i > 499) {
      continue;
    }

    if (line.length < 2) {
      continue;
    }

    // const lineArr: any = [line[0], line[1]];
    // console.log('lineArr', lineArr);

    state.proxies.push([line[0], line[1]]);

    // console.log(state.proxies);
  }

  return true;
};

const loadIPs = () => {
  for (let i = 0; i < state.proxies.length; i++) {
    const el = state.proxies[i];
    IP.push(`${el[0]}:${el[1]}-${i}`);
  }
  // console.log(IP);
};

const formData = () => {
  IP.forEach((i) => {
    // console.log(i);

    state.Data.append('ip_addr[]', i);
    // console.log(state.Data, 'Data');
  });
};

export const getIPlist = () => {
  state.loading = true;
  state.isShow = false;

  PcheckerService.IPlist(state.Data)
    .then((response: ResponseData) => {
      state.response = response.data;
      // console.log('=>>>>p', response.data);
      state.total_proxies = state.response.length;
      const workingProxies = state.response.filter((w: any) => w.working === true);
      state.working_proxies_array = workingProxies;
      state.working_proxies = workingProxies.length;

      const arr: any[] = [];
      state.working_proxies_array.map((element) => arr.push(element));
      // console.log('arr', arr);

      const list: string[] = [];
      arr.forEach((e) => {
        // console.log(e.ip);
        list.push(e.ip);
      });

      state.working_proxies_list = list.join('\r\n');

      const deadProxies = state.response.filter((w: any) => w.working === false);
      state.dead_proxies = deadProxies.length;
      state.loading = false;
      state.isShow = true;
    })
    .catch((e: Error) => {
      console.log(e);
    });
};

export const startCheck = function startCheck() {
  loadIPinput();
  if (state.proxies.length > 1) {
    loadIPs();
    formData();
    getIPlist();
    state.showChecker = false;
    state.showOutput = true;
    state.error = false;
  } else {
    console.log('err');
    state.showChecker = true;
    state.showOutput = false;
    state.error = true;
    state.input = '';
  }
};

export const saveProxies = (response: BlobPart) => {
  const fileURL = window.URL.createObjectURL(new Blob([response]));
  const fURL = document.createElement('a');
  fURL.href = fileURL;
  fURL.setAttribute('download', 'checked_proxies.txt');
  document.body.appendChild(fURL);
  fURL.click();
};
